import Cookies from "js-cookie";

export const generateAuthCookie = (token: string) =>
  Cookies.set("session", token, { expires: 12 / 24 });
